import React from "react";

function CloudReadiness() {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>Cloud Readiness</h1>
      <p style={{ color: "gray" }}>Content for Cloud Readiness will be added soon.</p>
    </div>
  );
}

export default CloudReadiness;
